import { render, staticRenderFns } from "./productTipPane.vue?vue&type=template&id=304b0a36&scoped=true"
import script from "./productTipPane.vue?vue&type=script&lang=js"
export * from "./productTipPane.vue?vue&type=script&lang=js"
import style0 from "./productTipPane.vue?vue&type=style&index=0&id=304b0a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b0a36",
  null
  
)

export default component.exports